import { memo } from 'react';
import { DatePicker } from 'antd';
import PropTypes from 'prop-types';


const { RangePicker } = DatePicker;
/*SumitG-08-12-23*/
const BzDateRangePicker = ({ handlePanelChange, handleKeyDown, disableFutureDates, className, renderExtraFooter, handleDateChange, presets, isPickerOpen, selectedRange, setIsPickerOpen }) => { // Hari K:10-11-2023: changed function name


    return (
        <RangePicker
            value={selectedRange}
            onChange={handleDateChange}
            ranges={presets}
            className={className}
            open={isPickerOpen}
            onOpenChange={(open) => {
                if (open) {
                    setIsPickerOpen(true);
                }
            }}
            disabledDate={disableFutureDates}
            onCalendarChange={handleDateChange}
            onPanelChange={handlePanelChange} // Hari K:10-11-2023: changed function name
            renderExtraFooter={renderExtraFooter}
            onKeyDown={handleKeyDown} // Hari K:20-12-2023: added function to allow user to enter only numbers
        />
    );
};

BzDateRangePicker.propTypes = {
    renderExtraFooter: PropTypes.func,
    handleDateChange: PropTypes.func,
    presets: PropTypes.object,
    isPickerOpen: PropTypes.bool, // hari K:04-12-2023 changed string to bool
    selectedRange: PropTypes.array,
    setIsPickerOpen: PropTypes.func,
};

BzDateRangePicker.defaultProps = {

};

export default memo(BzDateRangePicker);
